import {Component, Input} from '@angular/core';
import {IInventoryItem} from "../inventory-log.component";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'app-inventory-item',
  templateUrl: './inventory-item.component.html',
  styleUrls: ['./inventory-item.component.scss']
})
export class InventoryItemComponent {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  @Input() public items: IInventoryItem[];

}
